module.exports = __webpack_public_path__ + "static/media/pencil.46d43d28.svg";